import { render } from "./ApplicantView.vue?vue&type=template&id=b10218b0"
import script from "./ApplicantView.vue?vue&type=script&lang=js"
export * from "./ApplicantView.vue?vue&type=script&lang=js"

import "./ApplicantView.vue?vue&type=style&index=0&id=b10218b0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__